import { render } from "./ViewComfy.vue?vue&type=template&id=bae5ea3e"
import script from "./ViewComfy.vue?vue&type=script&lang=js"
export * from "./ViewComfy.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__